
function reMap(str: string, obj: { [key: string]: any }): string {
  try {
    return str.split(".").reduce((o, i) => o[i], obj).toString();
  } catch (e) {
    return str;
  }
}

const lang = (target: string, language: string) => {
  return window.data?reMap(
    language === "fr" ? `textFrench.${target}` : `textEnglish.${target}`,
    window.data
  ):target;
};

export default lang;
